import React, { useCallback } from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import AppointmentTopImg from '../../images/right-top-img3.png'
import CheckedInTopImg from '../../images/right-top-img2.png'
import { Link } from 'react-router-dom'
import { DoctorStore } from '../../stores'
import { Provider } from 'react-dnd/lib/cjs/DragDropContext'
import UpcomingAppointments from '../Appointments/UpcomingAppointments'


export default function DayStatus({
  offlineLength,
  onlineLength,
  checkedInLength
}) {
  const classes = useStyles()

  const { upcomingType } = DoctorStore.useStoreState(state => ({
    ...state.appointments
  }))


  const { setTele, setInPerson } = DoctorStore.useStoreActions(actions => ({
    ...actions.appointments
  }))

 React.useEffect(()=>{
  localStorage.removeItem("upcomingType")
 },[])

  const teleClicked = () => {
    setTele()
    window.location.href = '/doctor/appointments'
  }

  const inPersonClicked = () => {
    setInPerson()
    window.location.href = '/doctor/appointments'
  }
  return (
    <>
      <div
        className={classes.todayAppointments}
        style={{ backgroundImage: `url(${AppointmentTopImg})` }}>
        <Typography component="h4" style={{marginTop:'0px',fontFamily:'Poppins', fontWeight:'600', borderBottom:'1px rgba(255,255,255,0.1) solid',marginBottom:'20px',paddingBottom:'10px'}}>Upcoming Appointments</Typography>
        <Box className={classes.PatientSummary}>
          <Box className={classes.Online}>
            <Link onClick={teleClicked}>
              <p style={{ fontSize:'14px'}}>Tele-consult</p>
              <Typography variant="h1" component="h3" style={{color:'#d268f0',marginBottom:'10px'}}>
                {onlineLength}
              </Typography>
            </Link>
            <Link onClick={inPersonClicked}>
              <p style={{ fontSize:'14px'}}>In-Person-consult</p>
              <Typography variant="h1" component="h3" style={{color:'#d268f0'}}>
                {offlineLength}
              </Typography>
            </Link>
          </Box>
        </Box>
      </div>
      <div
        className={classes.checkedInPatients}
        style={{ backgroundImage: `url(${CheckedInTopImg})` }}>
        <p>Checked-In Patients</p>
        <h2>{checkedInLength}</h2>
      </div>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  todayAppointments: {
    background: 'none center top no-repeat',
    width: '100%',
    padding: '15px 5px',
    backgroundSize: 'cover',
    height: '220px',
    borderRadius: '10px',
    marginTop: '0px',
    boxShadow: '1px 1px 8px 0px rgba(50, 50, 50, 0.15);',
    '& h4': {
      fontSize: '18px',
      fontWeight: '200',
      textAlign: 'center',
      color: '#fff',
      marginTop: '15px',
      marginBottom: '10px'
    },
    '& p': {
      fontSize: '18px',
      color: '#fff',
      marginTop: '0px',
      textAlign: 'center'
    },
    '& h2': {
      fontSize: '20px',
      color: '#fff',
      marginTop: '10px',
      fontWeight: '200',
      marginBottom: '15px',
      textAlign: 'center'
    }
  },
  Online: {
    width: '100%',
    textAlign: 'center',
    '& h3': {
      fontSize: '30px',
      color: '#fff',
      marginTop: '0px',
      fontWeight: '600'
    },
    '& p': {
      fontSize: '18px',
      marginBottom: '0px'
    }
  },
  PatientSummary: {
    width: '100%',
    display: 'flex'
  },
  checkedInPatients: {
    background: 'none center top no-repeat',
    width: '100%',
    padding: '30px 0',
    backgroundSize: 'cover',
    height: '160px',
    marginTop: '20px',
    borderRadius: '10px',
    textAlign:'center',
    boxShadow: '1px 1px 8px 0px rgba(50, 50, 50, 0.15);',
    '& p': {
      fontSize: '18px',
      color: '#fff',
      marginTop: '-15px',
      fontFamily:'Poppins',
      fontWeight:'600',
      paddingBottom:'10px',
      borderBottom:'1px rgba(255,255,255,0.2) solid',
      marginBottom:'10px'
    },
    '& h2': {
      fontSize: '50px',
      color: '#fff',
      marginTop: '0px',
      fontWeight: '600',
      fontFamily:'Poppins',
      marginBottom: '0'
    }
  }
}))
